
import { Component, Vue, Prop } from 'vue-property-decorator'
import { NavBar, SpeakingUtility, MenuBar } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    MenuBar,
    NavBar,
    SpeakingUtility
  }
})
export default class TaskQuestionCard extends Vue {
  @Prop({ required: true })readonly obj: any

  data () {
    return {
      isLoading: false,
      taskId: null,
      remainTime: '',
      disabled: true,
      taskData: null,
      score: null,
      scoreReason: null,
      description: '',
      words: [],
      content: '',
      audioFilePath: '',
      processAudio: false,
      s2tCredits: 0
    }
  }

  mounted () {
    this.taskId = this.$route.params.taskId
    this.prepareTaskData()
    this.getTaskAudioFilePath()
    this.getAcountCreditsInfo()
  }

  fillRemainTime (due) {
    if (due) {
      var now = new Date()
      var days = (due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
      if (days <= 0) {
        this.remainTime = 'Expired'
      } else {
        var hours = (days - Math.floor(days)) * 24
        var mins = 0
        if ((hours - Math.floor(hours)) > 0) {
          mins = (hours - Math.floor(hours)) * 60
        }
        var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
        var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
        var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

        this.remainTime = `${daysString}${hoursString}:${minsString} h `
      }
    } else {
      this.remainTime = ''
    }
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.finish()
      },
      canCancel: true
    })
  }

  async save () {
    await this.updateOnServer(false)
  }

  async finish () {
    await this.updateOnServer(true)
  }

  async prepareTaskData () {
    this.isLoading = true
    try {
      var resp = this.obj
      if (resp.data) {
        this.taskData = JSON.parse(resp.data)
        this.words = this.taskData.dicionarios
        this.content = this.taskData.content
      }
      this.description = resp.description
      this.score = resp.score
      this.scoreReason = resp.scoreReason
      this.disabled = resp.completed || new Date(resp.due) <= new Date()
      this.fillRemainTime(new Date(resp.due))
      if (!this.taskId) {
        this.taskId = resp.id
      }
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async updateOnServer (completed) {
    this.isLoading = true
    var data = {
      content: this.content
    }
    try {
      const resp = await FetchWrapper.post(
        `${process.env.VUE_APP_SERVERURL}/updateQuestionTaskData`,
        { data: data, id: Number(this.taskId), completed }
      )
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Task saved Successfully',
        onConfirm: () => {
          if (completed) {
            window.location.href = '/home/tasks'
          }
        },
        canCancel: false
      })
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not save task data. ${e}`,
        canCancel: false
      })
    }
  }

  async getTaskAudioFilePath () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getTaskAudioFilePath/${this.taskId}`))
      this.audioFilePath = resp.filePath == null ? '' : resp.filePath
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get audio file path.',
        canCancel: false
      })
    }
  }

  async getAcountCreditsInfo () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/stats/getAcountCreditsInfo`))
      this.s2tCredits = resp.s2tCredits
      this.isLoading = false
      if (this.s2tCredits <= 0) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: 'You do not have any more Transcript credits. Gen button is blocked.',
          canCancel: true
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get Credits Information.',
        canCancel: false
      })
    }
  }

  sendAudio () {
    this.processAudio = true
  }

  async audioProcessingFinished (resp) {
    this.processAudio = false
    this.content = resp.content
  }
}
